import { useState } from 'react';

import TopProductsDoughnut from "./TopProductsDoughnut";
import DashboardCard from '../components/DashboardCard';
import PeriodSelector from '../components/PeriodSelector';

import { CircularProgress, Grid, Stack } from '@mui/material';

import { DATE_RANGES, PRODUCT_DEFAULT } from "../../../../constants/admin/dashboard_constants";
import { getDashboardPeriodRange } from '../../../../helpers/admin/dashboard/dashboardHelper';
import DashboardOrdersExportButton from '../components/DashboardOrdersExportButton';

const PERIOD_OPTIONS = DATE_RANGES.map(({ key, label }) => ({
    value: key,
    label
}));

const TopProducts = ({
    today, filteredRange, dateRanges, topProductsData, ensureAnnualData
}) => {
    const [selectedPeriod, setSelectedPeriod] = useState('todayData');
    const [loadingAnnual, setLoadingAnnual] = useState(false);
    const selectedOption = DATE_RANGES.find(({ key }) => key === selectedPeriod)
        || DATE_RANGES[0];
    const selectedDateLabel = dateRanges[selectedOption.rangeKey] || '';
    const chartLabel = `${selectedOption.label} (${selectedDateLabel})`;
    const currentData = topProductsData[selectedPeriod] || PRODUCT_DEFAULT;
    const exportRange = getDashboardPeriodRange(
        selectedOption.rangeKey, today, filteredRange
    );
    const changePeriod = async (period) => {
        if (period === 'annualData') {
            setLoadingAnnual(true);
            try {
                const loaded = await ensureAnnualData();
                if (!loaded)
                    return;
            } finally {
                setLoadingAnnual(false);
            }
        }
        setSelectedPeriod(period);
    };

    return (
        <Grid item xl={8} lg={8} md={8} sm={12} xs={12}
            sx={{ mx: 'auto' }}>
            <DashboardCard
                title="Top 10 productos"
                action={
                    <Stack direction="row" alignItems="center" spacing={1}>
                        {loadingAnnual && <CircularProgress size={18} />}
                        <DashboardOrdersExportButton
                            reportType="top_products"
                            range={exportRange}
                            filename={`pedidos_top-productos_${selectedOption.rangeKey}.csv`}
                        />
                        <PeriodSelector
                            menuId="top-products-period-menu"
                            value={selectedPeriod}
                            options={PERIOD_OPTIONS}
                            onChange={changePeriod}
                            ariaLabel="Seleccionar periodo de productos"
                        />
                    </Stack>
                }
            >
                <TopProductsDoughnut label={chartLabel} data={currentData} />
            </DashboardCard>
        </Grid>
    );
};

export default TopProducts;
